import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import CTABand from "../components/CTABand";
import { TECHNOLOGIES } from "../data/content";

const Technologies = () => (
  <main data-testid="technologies-page">
    <PageHeader
      eyebrow="Our Stack"
      title="Technologies"
      description="A modern, carefully chosen technology stack across backend, frontend, cloud, data and AI."
    />
    <section className="bg-white py-20 lg:py-24">
      <div className="container-site grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TECHNOLOGIES.map((tech, i) => (
          <Reveal key={tech.name} delay={(i % 3) * 70}>
            <div
              className="group flex h-full items-center justify-between border border-border bg-white p-7 transition-colors duration-200 hover:border-brand-red"
              data-testid={`technology-card-${tech.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div>
                <h2 className="font-heading text-lg font-semibold transition-colors duration-200 group-hover:text-brand-red">
                  {tech.name}
                </h2>
                <p className="mt-1.5 text-sm text-brand-grey">{tech.note}</p>
              </div>
              <div className="ml-4 h-8 w-1 shrink-0 bg-brand-surface transition-colors duration-200 group-hover:bg-brand-red" aria-hidden="true" />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
    <CTABand />
  </main>
);

export default Technologies;
